import { FC } from 'react';
import {
  Files,
  HeartStraight,
  UserCircle,
  AddressBook,
} from '@phosphor-icons/react';
import { useSelector } from 'react-redux';

import {
  avatarList,
  hairColorPalette,
  shirtColorPalette,
  skinColorPalette,
} from 'enrollment/app/constants';
import { FamilyDrawerDisplayPicture } from 'enrollment/features/Family/FamilyDetailsPage/FamilyDrawerDisplayPicture';

export interface NavIconsProps {
  navIcon: string;
}

export const NavIcons: FC<NavIconsProps> = ({ navIcon }) => {
  const profileAvatar = useSelector(
    (state: any) => state.enrollment?.subscriber?.subscriber_profile?.avatar
  );

  const profilePicture = useSelector(
    (state: any) =>
      state.enrollment?.subscriber?.subscriber_profile?.profile_picture
  );

  const avatarName =
    typeof profileAvatar === 'string' ? profileAvatar.split('_')[0] : '';
  const avatarPicture = avatarList?.filter(
    (item) => profileAvatar && avatarName === item.name
  );
  const avatarSkincolor = skinColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[1] === item.name
  );

  const avatarHairColor = hairColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[2] === item.name
  );

  const avatarShirtColor = shirtColorPalette?.filter(
    (item) =>
      typeof profileAvatar === 'string' &&
      profileAvatar.split('_')[3] === item.name
  );

  return (
    <>
      {navIcon === 'profile' &&
        (profileAvatar ? (
          <div className="nav-icon-avatar-picture">
            <FamilyDrawerDisplayPicture
              saveAvatarName={avatarPicture[0]?.name}
              saveAvatarSkinTone={avatarSkincolor[0]?.colorCode}
              saveAvatarHairColor={avatarHairColor[0]?.colorCode}
              saveAvatarShirtColor={avatarShirtColor[0]?.colorCode}
              size={25}
            />
          </div>
        ) : profilePicture ? (
          <img
            src={profilePicture}
            className="nav-icon-profile-picture"
            alt="profile icon"
          />
        ) : (
          <UserCircle
            data-testid="profile-icon"
            className="heading-icon"
            size={24}
            weight="duotone"
          />
        ))}
      {navIcon === 'benefits' && (
        <HeartStraight
          data-testid="benefits-icon"
          className="heading-icon"
          size={24}
          weight="duotone"
        />
      )}
      {navIcon === 'documents' && (
        <Files
          data-testid="documents-icon"
          className="heading-icon"
          size={24}
          weight="duotone"
        />
      )}
      {navIcon === 'company' && (
        <Files
          data-testid="company-icon"
          className="heading-icon"
          size={24}
          weight="duotone"
        />
      )}
      {navIcon === 'admin' && (
        <Files
          data-testid="admin-icon"
          className="heading-icon"
          size={24}
          weight="duotone"
        />
      )}
      {navIcon === 'account' && (
        <AddressBook
          data-testid="account-icon"
          className="heading-icon"
          size={24}
          weight="duotone"
        />
      )}
    </>
  );
};
